<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header">
    <span class="title">Détail du document</span>
    <hr>
  </mat-card-title>
  <mat-card-content class="container-content content">

    <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">

      <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
        <div fxFlex="70" fxFlex.gt-sm="70">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Nom du document</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.PdfFileName }}" type="text" readonly disabled>
          </mat-form-field>
        </div>
        <div fxFlex="30" fxFlex.gt-sm="30">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Type de facture</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.InvoiceTypeLabel }}" type="text" readonly
              disabled>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
        <div fxFlex="50" fxFlex.gt-sm="50">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Date OCR</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.OcrDate | date:'dd/MM/yyyy HH:mm:ss' }}"
              type="text" readonly disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.gt-sm="50">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Date de réception</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.ImportDate | date:'dd/MM/yyyy HH:mm:ss' }}"
              type="text" readonly disabled>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="IsPicked">
        <div fxFlex="70" fxFlex.gt-sm="70">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Traité par</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.PickedByUserName }}" type="text" readonly
              disabled>
          </mat-form-field>
        </div>
        <div fxFlex="30" fxFlex.gt-sm="30">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Traité le</mat-label>
            <input matInput value="{{ importMissingInvoiceNumberDocument.PickedAt | date:'dd/MM/yyyy HH:mm:ss' }}"
              type="text" readonly disabled>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Commentaire</mat-label>
          <textarea matInput [(ngModel)]="comment" matAutosizeMinRows=6 matAutosizeMaxRows=6  style="height: 100px;">
          </textarea>
        </mat-form-field>
      </div>

    </div>

  </mat-card-content>
  <mat-card-footer class="container-footer">
    <div class="modal-footer d-table w-100">
      <div class="row" fxLayoutAlign="space-around start">
        <div class="column" *ngIf="IsPickedByMe">
          <button type="button" mat-stroked-button class="currentBtn" matTooltip="Relâcher le document"
            (click)="onUnpick()">
            Relâcher
          </button>
        </div>
        <div class="column" *ngIf="showViewButton">
          <button type="button" mat-stroked-button class="currentBtn" matTooltip="Voir le document"
            (click)="onPdfViewer()">
            Voir
          </button>
        </div>
        <div class="column">
          <button type="button" mat-stroked-button class="currentBtn" matTooltip="Télécharger le document"
            (click)="onDownload()">
            Télécharger
          </button>
        </div>
        <div class="column">
          <button type="button" mat-stroked-button class="currentBtn" matTooltip="Enregistrer le commentaire"
            (click)="onSaveComment()">
            Enregistrer
          </button>
        </div>
        <div class="column" *ngIf="!IsPickedByMe">
          <button type="button" mat-stroked-button class="currentBtnColor" matTooltip="Traiter le document"
            (click)="onPick()">
            Traiter
          </button>
        </div>
        <div class="column" *ngIf="showInjectButton">
          <button type="button" mat-stroked-button class="currentBtnColor" matTooltip="Injecter la facturer"
            (click)="onInject()">
            Réinjecter
          </button>
        </div>
      </div>
    </div>
  </mat-card-footer>
</mat-card>
